import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../components/Section';
import { galleryImages } from '../data/mock';
import SEO from '../lib/SEO';

const FILTERS = ['All', 'Inspections', 'Lab', 'Cargo', 'Team'];

export default function Gallery() {
  const [active, setActive] = useState('All');
  const [preview, setPreview] = useState(null);
  const items = active === 'All' ? galleryImages : galleryImages.filter((g) => g.category === active);

  return (
    <div className="font-sans-body">
      <SEO title="Gallery | Apex Quality Control" description="A visual look at the work — from factory floor to final shipment." />
      <section className="bg-aqc-cream">
        <div className="container-aqc py-16 lg:py-20">
          <span className="eyebrow">Gallery</span>
          <h1 className="mt-4 font-serif text-[2.4rem] sm:text-[3rem] font-semibold text-aqc-navy">Field Gallery.</h1>
          <p className="mt-4 text-aqc-muted max-w-2xl">A visual look at the work — from factory floor to final shipment.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="container-aqc">
          <div className="flex flex-wrap justify-center gap-2">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className={`px-5 py-2 rounded-full text-sm font-medium border transition-colors ${
                  active === f
                    ? 'bg-aqc-navy text-white border-aqc-navy'
                    : 'bg-white text-aqc-navy border-aqc-line hover:border-aqc-navy'
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((g, i) => (
              <button
                key={i}
                onClick={() => setPreview(g)}
                className="group relative overflow-hidden rounded-2xl border border-aqc-line bg-aqc-cream aspect-[4/3]"
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-aqc-navy/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-3 left-4 right-4 text-left text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                  {g.alt}
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {preview && (
        <div
          className="fixed inset-0 z-[70] bg-black/80 flex items-center justify-center p-4"
          onClick={() => setPreview(null)}
        >
          <img src={preview.src} alt={preview.alt} className="max-w-full max-h-full rounded-xl" />
        </div>
      )}
    </div>
  );
}
